import { render, staticRenderFns } from "./ShopRoot.vue?vue&type=template&id=5c4b0ec4"
import script from "./ShopRoot.vue?vue&type=script&lang=js"
export * from "./ShopRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports